export default "__VITE_ASSET__9c9ee35e__"